var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video--holder ", on: { click: _vm.runClick } },
    [
      _c("div", { staticClass: "thumbnail" }, [
        _c("div", { staticClass: "details--video" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "play-icon" },
            [
              _c("font-awesome-icon", {
                attrs: { icon: ["far", "play-circle"] }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "video-title" }, [
          _vm._v(" " + _vm._s(_vm.title) + " ")
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo" }, [
      _c("img", { attrs: { src: "/svg/logo.svg" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }